<template>
  <b-loading v-if="loading" active></b-loading>
  <div v-else-if="post">
    <h2 class="title is-2">{{ post.title }}</h2>
    <p class="subtitle">{{ post.teaser }}</p>
    <h3>userID: {{ post.profileID }}</h3>
    <h3>Date: {{ post.postedAt }}</h3>
    <h3>Privacy: {{ post.privacy }}</h3>
    <div v-for="content in contents" :key="content.id" class="box">
      <media-gallery :collection="mediaFor(content.id)"></media-gallery>
      <hr/>
      {{ content.body }}
      <br />
      <b>Location:</b> {{ content.location }}
    </div>
    <div class="buttons">
      <b-button tag="router-link" :to="{ name: 'profile.show' }">Back</b-button>
      <b-button tag="router-link" :to="{ name: 'post.edit', params: { id: post.id }}">Edit</b-button>
      <b-button @click.prevent="deletePost" type="is-danger">Delete</b-button>
    </div>
  </div>
</template>

<script>
import HasPost from '@/mixins/has-post'
import { deleteRecord } from '@/utils/records'
import MediaGallery from './media-gallery'
export default {
  mixins: [ HasPost ],
  components: {
    MediaGallery
  },
  methods: {
    async deletePost () {
      await deleteRecord({ record: this.post })
      this.$router.push({ name: 'profile.show' })
    }
  }
}
</script>
